export default __webpack_public_path__ + "static/media/haelo-show.b82ad968.jpg";